"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AlwaysActiveLinks = require("./AlwaysActiveLinks");
Object.keys(_AlwaysActiveLinks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AlwaysActiveLinks[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AlwaysActiveLinks[key];
    }
  });
});
var _AppConfig = require("./AppConfig");
Object.keys(_AppConfig).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppConfig[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AppConfig[key];
    }
  });
});
var _BurgerMenuTabNames = require("./BurgerMenuTabNames");
Object.keys(_BurgerMenuTabNames).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BurgerMenuTabNames[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BurgerMenuTabNames[key];
    }
  });
});
var _Catalogue = require("./Catalogue");
Object.keys(_Catalogue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Catalogue[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Catalogue[key];
    }
  });
});
var _Categories = require("./Categories");
Object.keys(_Categories).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Categories[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Categories[key];
    }
  });
});
var _FavoritesLink = require("./FavoritesLink");
Object.keys(_FavoritesLink).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FavoritesLink[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FavoritesLink[key];
    }
  });
});
var _NavigationItem = require("./NavigationItem");
Object.keys(_NavigationItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NavigationItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NavigationItem[key];
    }
  });
});
var _OurStoryLinks = require("./OurStoryLinks");
Object.keys(_OurStoryLinks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OurStoryLinks[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OurStoryLinks[key];
    }
  });
});
var _Product = require("./Product");
Object.keys(_Product).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Product[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Product[key];
    }
  });
});
var _ReferralType = require("./ReferralType");
Object.keys(_ReferralType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReferralType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ReferralType[key];
    }
  });
});
var _RequiredFields = require("./RequiredFields");
Object.keys(_RequiredFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RequiredFields[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _RequiredFields[key];
    }
  });
});
var _SpecialLinks = require("./SpecialLinks");
Object.keys(_SpecialLinks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SpecialLinks[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SpecialLinks[key];
    }
  });
});
var _SuggestionsAndResults = require("./SuggestionsAndResults");
Object.keys(_SuggestionsAndResults).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SuggestionsAndResults[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SuggestionsAndResults[key];
    }
  });
});
var _TranslationKey = require("./TranslationKey");
Object.keys(_TranslationKey).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TranslationKey[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TranslationKey[key];
    }
  });
});
var _VipOrdersTypes = require("./VipOrdersTypes");
Object.keys(_VipOrdersTypes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VipOrdersTypes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VipOrdersTypes[key];
    }
  });
});